<template>
  <div>
    <div class="header">
      <img
        src="@/assets/images/bannerlooser.png"
        srcset="@/assets/images/bannerlooser-p-500.png 500w, @/assets/images/bannerlooser-p-800.png 800w, @/assets/images/bannerlooser-p-1080.png 1080w, @/assets/images/bannerlooser-p-1600.png 1600w, @/assets/images/bannerlooser.png 1920w"
        sizes="(max-width: 1920px) 100vw, 1920px"
        alt
        class="image-8"
      />
    </div>
    <div class="content-loose">
      <div id="coupon_loose_content" class="content-block-loosing">
        <div class="block-titile">Versuchen Sie Ihr Glück morgen erneut!</div>
        <div class="div-block-9">
          <div class="block-title-2">Auf welches Rezept haben Sie Lust?</div>
          <ReceiptList />
        </div>
      </div>
    </div>
  </div>
</template>
<style>
.card-recipes-title {
  display: none !important;
}
.separator-horizontal-image {
  display: none;
}
</style>
<script>
import ReceiptList from "@/components/ReceiptList.vue";

export default {
  name: "LoserView",
  props: ["receiptList"],
  components: {
    ReceiptList
  }
};
</script>
